import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface CobrandingTheme {
  secondaryColor: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: ({ secondaryColor }: CobrandingTheme) => ({
      color: secondaryColor,
    }),
    title: {
      color: 'rgb(1, 70, 81)',
      fontWeight: 600,
    },
  }),
);

export default useStyles;
